module.exports = __webpack_public_path__ + "img/zshy@2x.406d71a3.png";